module.exports = __webpack_public_path__ + "img/img-box-4.260a8103.png";